import gql from 'graphql-tag';

import {
  ChannelFragment,
  AddressFragment,
  ProfileFragment,
  TenantFragment,
} from '../fragments';

export const queryChannelsByRelationship = gql`
  ${AddressFragment}
  ${ProfileFragment}
  ${ChannelFragment}
  ${TenantFragment}

  query ChannelsByRelationship(
    $pagination: PaginationInput
    $search: ChannelRelationshipSearch!
    $skipPagination: Boolean
    $includeLeases: Boolean! = false
  ) {
    channelsByRelationship(
      pagination: $pagination
      search: $search
      skipPagination: $skipPagination
      includeLeases: $includeLeases
    ) {
      pageInfo {
        start
        total
        perPage
      }
      items {
        _id
        channel {
          ...ChannelFragment
          _createdBy {
            _id
          }
          _updatedBy {
            _id
          }
          ...TenantFragment
        }
        relatedTo {
          ...ChannelFragment
        }
      }
    }
  }
`;

export default queryChannelsByRelationship;
